import { NotFound } from '@/components/pages/Errors/NotFound'
import { Page } from '@/core/architecture'

import { TicketShareCopyTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * TicketShareCopy Page
 * Implemented as a practical sample.
 */
export const TicketShareCopy: Page = () => {
  const { state, actions } = useViewModel()

  if (!state.loading && !state.serial) {
    return <NotFound useNextRouter={false} />
  }

  return <TicketShareCopyTemplate state={state} {...actions} />
}
